import { Delivery } from "./delivery";
import * as Styled from "./style";
import { ProductInfo } from "~/components/blocks/product/common/blocks/product-tab-contents/product-info";
import { Purchased } from "~/components/blocks/product/common/blocks/product-tab-contents/purchased";
import { Review } from "~/components/blocks/product/common/blocks/product-tab-contents/review";
import { STAGE_SELECT_TABS } from "~/components/blocks/product/const";
import { isVideoStageSeason } from "~/components/blocks/product/type-guard";
import type { G_GetVideoQuery } from "~/lib/graphql";

export type VideoStageSeasonTabContentsProps = {
  /** videoクエリを叩いて取得したデータ */
  videoData: G_GetVideoQuery["video"];
  /** 現在選択されている`TabTitle` */
  selectedTabValue: string;
  /** 購入済みの合計数 */
  totalPurchasedLength: number;
};

/**
 * 舞台 | 作品末端のタブに紐づくコンテンツを表示するコンポーネント
 * - SEO的な都合上、Tab切り替えでコンテンツのマウント/アンマウントをするのは良くない
 * - なので、全てレンダリングした状態で表示/非表示を指定する
 * @param props {@link VideoStageSeasonTabContentsProps}
 */
export const VideoStageSeasonTabContents = (props: VideoStageSeasonTabContentsProps) => {
  const { videoData, selectedTabValue, totalPurchasedLength } = props;

  return (
    <Styled.DivContentsWrapper>
      <Styled.DivContentsBox isShow={selectedTabValue === STAGE_SELECT_TABS.DELIVERY}>
        {isVideoStageSeason(videoData) && <Delivery videoStageSeasonData={videoData} />}
      </Styled.DivContentsBox>

      <Styled.DivContentsBox isShow={selectedTabValue === STAGE_SELECT_TABS.PURCHASED}>
        <Purchased seasonType={videoData.seasonType} totalPurchasedLength={totalPurchasedLength} />
      </Styled.DivContentsBox>

      <Styled.DivContentsBox isShow={selectedTabValue === STAGE_SELECT_TABS.PRODUCT_INFO}>
        <ProductInfo videoData={videoData} />
      </Styled.DivContentsBox>

      <Styled.DivContentsBox isShow={selectedTabValue === STAGE_SELECT_TABS.REVIEW}>
        <Review videoData={videoData} />
      </Styled.DivContentsBox>
    </Styled.DivContentsWrapper>
  );
};
